import React, { memo, Fragment } from 'react';
import { Button, Spinner } from 'reactstrap';

const ButtonLoader = ({ loader, type = "submit", onClick, disabled, text = 'Submit', spinnerSize = 'md', ...rest }) => {
    let hidden = loader ? loader : disabled
    return (
        <Button
            onClick={onClick}
            disabled={hidden}
            type={type}
            style={hidden ? { cursor: "not-allowed" } : {}}
            {...rest}
        >
            {
                loader ? (
                    <Fragment>
                        <Spinner size={spinnerSize} className="mr-1" />
                        Loading...
                    </Fragment>
                ) : text
            }
        </Button>
    );
};

export default memo(ButtonLoader);
